import { Source } from '@trustero/trustero-api-web/lib/source/source_pb'
import { ChatCitation } from '@trustero/trustero-api-web/lib/chatcontext/chatcontext_pb'
import React, { useContext } from 'react'

// Local file info for previewing files that haven't been uploaded yet
export type LocalFileSource = {
  file: File
  name: string
}

type DocumentSourceContextType = {
  currentDocumentSource: Source | ChatCitation | null
  setCurrentDocumentSource: React.Dispatch<
    React.SetStateAction<Source | ChatCitation | null>
  >
  // For previewing local files (not yet uploaded)
  currentLocalFile: LocalFileSource | null
  setCurrentLocalFile: React.Dispatch<
    React.SetStateAction<LocalFileSource | null>
  >
}

export const DocumentSourceContext =
  React.createContext<DocumentSourceContextType>({
    currentDocumentSource: null,
    setCurrentDocumentSource: () => null,
    currentLocalFile: null,
    setCurrentLocalFile: () => null,
  })

export const useDocumentSourceContext = (): DocumentSourceContextType =>
  useContext(DocumentSourceContext)

export const DocumentSourceProvider = ({
  children,
}: {
  children: JSX.Element
}): JSX.Element => {
  const [currentDocumentSource, setCurrentDocumentSource] = React.useState<
    Source | ChatCitation | null
  >(null)
  const [currentLocalFile, setCurrentLocalFile] =
    React.useState<LocalFileSource | null>(null)

  return (
    <DocumentSourceContext.Provider
      value={{
        currentDocumentSource,
        setCurrentDocumentSource,
        currentLocalFile,
        setCurrentLocalFile,
      }}
    >
      {children}
    </DocumentSourceContext.Provider>
  )
}
